import { handleActions } from '@housinganywhere/safe-redux';
import { ActionTypes, NavBarActionsType } from './actions';
import { MobileMenuType } from './types';

interface State {
  isShowingAuthModal: boolean;
  currentMenu?: MobileMenuType;
}

export const initialState = {
  isShowingAuthModal: false,
  currentMenu: undefined,
};

const reducer = handleActions<State, ActionTypes, NavBarActionsType>(
  {
    [ActionTypes.SHOW_MODAL]: _state => ({
      ..._state,
      isShowingAuthModal: true,
    }),
    [ActionTypes.HIDE_MODAL]: _state => ({
      ..._state,
      isShowingAuthModal: false,
    }),
    [ActionTypes.OPEN_MOBILE_DRAWER]: _state => ({
      ..._state,
      currentMenu: MobileMenuType.main,
    }),
    [ActionTypes.CLOSE_MOBILE_DRAWER]: _state => ({
      ..._state,
      currentMenu: undefined,
    }),
    [ActionTypes.SWITCH_MENU]: (_state, { payload }) => ({
      ..._state,
      currentMenu: payload,
    }),
  },
  initialState,
);

export default reducer;
